import React from "react";
import CardArrow from "./CardArrow";

interface HeaderDropdownProps {
  children?: React.ReactNode;
  vs?: boolean;
  className?: string;
  timer?: boolean;
  onFirstTimerEnd?: () => void;
  onSecondTimerEnd?: () => void;
  onThirdTimerEnd?: () => void;
  selected?: number;
  logos?: boolean;
  team1Logo?: string;
  team2Logo?: string;
  ajioIconHeight?: string | number;
  ajioIconWidth?: string | number;
  startTime?: number;
  startRound?: number;
  onLogoClick?: () => void;
}

function HeaderDropdown({
  children,
  vs,
  className,
  timer,
  onFirstTimerEnd,
  onSecondTimerEnd,
  onThirdTimerEnd,
  selected,
  logos,
  team1Logo,
  team2Logo,
  ajioIconHeight,
  ajioIconWidth,
  startRound,
  startTime,
  onLogoClick,
}: HeaderDropdownProps) {
  return (
    <div className="relative" style={{ zIndex: 20, width: "100%" }}>
      <div className={`containerHeaderDropdownContentContainer ${className}`}>
        {children}
      </div>
      <CardArrow
        vs={vs}
        timer={timer}
        onFirstTimerEnd={onFirstTimerEnd}
        onSecondTimerEnd={onSecondTimerEnd}
        onThirdTimerEnd={onThirdTimerEnd}
        selected={selected}
        ajioIconHeight={ajioIconHeight}
        ajioIconWidth={ajioIconWidth}
        startRound={startRound}
        startTime={startTime}
        onLogoClick={onLogoClick}
      />
    </div>
  );
}

export default HeaderDropdown;
